import { attr, fk, many } from 'redux-orm';
import Model from '../base-model';
import discussionReducers from './discussion.reducer';
import { discussionActions } from './discussion.action';

/**
 * Teacher
 * @typedef {Object} Discussion
 * @property {string}    id
 * @property {ForumUser} creator
 * @property {string}    title
 * @property {string}    content
 * @property {Date}      createAt
 * @property {string}    replies
 * @property {number}    postCount
 */

export class Discussion extends Model {

    static reducer(action, Self, session) {
        switch (action.type) {
        case discussionActions.saveDiscussion:
            discussionReducers.saveDiscussion(session, action.discussion, action.topicId);
            break;
        case discussionActions.removeDiscussion:
            discussionReducers.removeDiscussion(session, action.id);
            break;
        case discussionActions.increasePostCount:
            discussionReducers.increasePostCount(session, action.id);
            break;
        case discussionActions.decreasePostCount:
            discussionReducers.decreasePostCount(session, action.id);            
            break;
        default:
            return undefined;
        }
    }

    toString() {
        return `Discussion: ${this.title}`
    }
}

Discussion.modelName = 'Discussion';

Discussion.fields = {
    id: attr(),
    creator: fk('ForumUser'),
    title: attr(),
    content: attr(),
    createAt: attr(),
    posts: many('Post', 'discussion'),
    topic: fk('Topic', 'discussions'),
    postCount: attr(),
}